import { bhEnv } from '@lib/env';
import axios, { AxiosResponse } from 'axios';

const client = axios.create({ baseURL: `${bhEnv.backendUrl}/bh/store` })

function request<T>(
  path: string,
  method: HTTPMethod = 'GET',
  payload: any = {}
) {
  const params = new URLSearchParams();

  // Have to do this because Medusa expects (url-encoded) brackets in querystring parameters
  // for arrays, and by default, URLSearchParams does not include them at all, which throws a
  // validation error on the back end.
  Object.entries(payload).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item, i) => {
        params.append(`${key}[${i}]`, item);
      });
    } else {
      params.append(key, `${value}`);
    }
  });


  const options = {
    method,
    withCredentials: true,
    url: method === 'GET' ? `${path}?${params.toString()}` : path,
    data: method !== 'GET' ? params : undefined,
    json: true,
    validateStatus: () => true,
  }
  return client(options) as Promise<AxiosResponse<T>>;
}

/** Create product in Medusa for given quote and return the id of the resulting product variant */
export async function postQuoteProduct(
  productType: ProductType,
  quoteId: QAID
): Promise<MedusaID> {
  const response = await request<MedusaID>(
    `/quote-product/${quoteId}?productType=${productType}`,
    'POST'
  )
  return response.data
}

/** Notify backend of customer address update */
export async function putCustomerDidUpdateAddress(): Promise<void> {
  await request(`/customers/did-update-address`, 'PUT')
}

export async function fetchProductGroupsForProducts(
  productIds: MedusaID[]
): Promise<{ [key: MedusaID]: MedusaID[] }> {

  // console.log("ProductIds: ", productIds)
  // Put productIds into querystring parameter called productIds
  // const productIdsString = productIds.join(',')
  // const path = `/products/product-visibility-groups?productIds=${productIdsString}`
  // console.log("Path: ", path)


  const response = await request<{ [key: MedusaID]: MedusaID[] }>(
    `/products/product-visibility-groups`,
    'GET',
    { productIds }
  )

  return response.data
}